/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Auth_DescriptionInputs */

const he_notifications_auth_description = /** @type {(inputs: Notifications_Auth_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עקבו אחר שינויי מחיר למוצר זה מהחשבון שלכם`)
};

const en_notifications_auth_description = /** @type {(inputs: Notifications_Auth_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track price changes for this product from your account`)
};

/**
* | output |
* | --- |
* | "Track price changes for this product from your account" |
*
* @param {Notifications_Auth_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_auth_description = /** @type {((inputs?: Notifications_Auth_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Auth_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_auth_description(inputs)
	return en_notifications_auth_description(inputs)
});